import { Component, Vue } from 'vue-property-decorator'
import { TransportButton } from '@/common/utils/modules-util'
import CommonConstants from '@/common/CommonConstants'
import { fixedContent } from '@/assets/js/main.js'
import OtherUrlConstants from '@/common/OtherUrlConstants'

@Component({
  name: 'CAAG1140',
  components: {}
  })
export default class CAAG1140Controller extends Vue {
  private CommonConstants = CommonConstants
  /**
   * 画面要素描画後処理
   */
  async mounted() {
    await this.init()

    this.$nextTick(() => {
      fixedContent()
      const transportButton = new TransportButton('.js-write-log')
    })
  }

  /**
   * 初期処理
   */
  private async init() {}

  /**
   * コールセンター番号リンク押下
   */
  private callCenter(phoneNumber: string) {
    window.open('tel:' + phoneNumber, '_self')
  }

  /**
   * 移換手続き説明動画リンク押下
   */
  private gotoTransferProcedureExplanation() {
    window.open(OtherUrlConstants.TRANSFER_PROCEDURE_EXPLANATION + 'DCDLweb1140', '_blank')
  }

  /**
   * 企業型DC資格喪失時のお手続きのご案内リンク押下
   */
  private gotoKojingataPortal() {
    window.open(OtherUrlConstants.INFORMATION_ON_PROCEDURES, '_blank')
  }

  /**
   * 裁定請求お手続きナビリンク押下
   */
  private gotoRcptOfOldAgeBnft() {
    window.open(OtherUrlConstants.OLD_AGE_BENEFIT_RECIPIENT, '_blank')
  }

  /**
   * 年金受取額シミュレーションリンク押下
   */
  private gotoCAHG1220() {
    this.$router.push({ name: 'cahg1220' })
  }

  /**
   * 資格喪失後や一般のお手続きはこちらリンク押下
   */
  private gotoDCDoor() {
    window.open(OtherUrlConstants.DC_PERSONAL_PORTAL, '_blank')
  }

  /**
   * 戻るリンク押下
   */
  private gotoCBEG1010() {
    this.$router.push({ name: 'cbeg1010' })
  }

  /**
   * テキスト・マニュアル（CAJG1010）画面の「その他資料」エリアへ遷移する。
   */
  private gotoCAJG1010() {
    this.$router.push({ name: 'cajg1010', hash: '#other-materials' })
  }

  /**
   * 外部サイト：給付金をお受け取りになる方 へ（URL:https://www.jis-t.co.jp/support/recipient.html）を別タブで表示する。
   */
  private gotoPersonsReceivingBenefits() {
    window.open(OtherUrlConstants.JIST_SUPPORT_FOR_BENEFIT_RECIPIENTS, '_blank')
  }
}
